import { Table, TableCell, TableRow, Checkbox } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateEndorsementFormData } from 'src/features/rfqDataSlice';

function DynamicForm({ policyDetails, formNumber }) {
  const dispatch = useDispatch();
  const [dynamicFormdata, setDynamicFormData] = useState([]);

  // Dynamically get the correct data based on formNumber
  const formDataSource =
    formNumber === 1
      ? policyDetails?.dynamicFormData
      : formNumber === 2
      ? policyDetails?.secondDynamicFormData
      : formNumber === 3
      ? policyDetails?.thirdDynamicFormData
      : [];

  const handleCheckboxChange = (groupIndex, fieldIndex, formInput) => {
    const rowId = `${groupIndex}-${fieldIndex}`;

    setDynamicFormData((prev) => {
      if (prev.some((item) => item.id === rowId)) {
        return prev.filter((item) => item.id !== rowId);
      } else {
        return [...prev, { id: rowId, data: formInput }];
      }
    });
  };

  const isChecked = (groupIndex, fieldIndex) =>
    dynamicFormdata.some((item) => item.id === `${groupIndex}-${fieldIndex}`);

  useEffect(() => {
    if (formNumber === 1) {
      dispatch(updateEndorsementFormData({ dynamicFormData: dynamicFormdata }));
    } else if (formNumber === 2) {
      dispatch(updateEndorsementFormData({ secondDynamicFormData: dynamicFormdata }));
    } else if (formNumber === 3) {
      dispatch(updateEndorsementFormData({ thirdDynamicFormData: dynamicFormdata }));
    }
  }, [formNumber, dynamicFormdata, dispatch]);

  return (
    <Table style={{ pointerEvents: 'none' }}>
      {formDataSource?.map((form, groupIndex) => (
        <React.Fragment key={groupIndex}>
          {form?.groupName && (
            <TableRow>
              <TableCell
                className="heading"
                colSpan={3}
                style={{
                  background: 'rgb(9 84 174)',
                  color: '#fff',
                  paddingTop: '6px',
                  paddingBottom: '6px',
                  fontWeight: 'bold',
                }}
              >
                {form?.groupName}
              </TableCell>
            </TableRow>
          )}
          {form?.masterForms?.map((formInputs, fieldIndex) => {
            const commonLabelStyle = {
              width: '470px',
              paddingLeft: '0px',
              fontStyle: formInputs.style?.italic ? 'italic' : 'normal',
              fontWeight: formInputs.style?.bold ? 'bold' : 'normal',
              textDecoration: formInputs.style?.underline ? 'underline' : 'none',
            };

            const commonValueStyle = {
              paddingLeft: '2px',
              fontStyle: formInputs.style?.italic ? 'italic' : 'normal',
              fontWeight: formInputs.style?.bold ? 'bold' : 'normal',
              textDecoration: formInputs.style?.underline ? 'underline' : 'none',
            };

            const rowId = `${groupIndex}-${fieldIndex}`;

            const renderValue = () => {
              if (
                formInputs.type === 'TextField' ||
                formInputs.type === 'Textarea' ||
                formInputs.type === 'Calendar'
              ) {
                return Array.isArray(formInputs?.value) && formInputs.isIncremental
                  ? formInputs.value.length > 0
                    ? formInputs.value.join(', ')
                    : 'N/A'
                  : !formInputs?.value || formInputs?.value === ''
                  ? 'N/A'
                  : formInputs?.value;
              }

              if (formInputs.type === 'DatePicker') {
                if (Array.isArray(formInputs?.value) && formInputs.isIncremental) {
                  return formInputs.value.length > 0
                    ? formInputs.value
                        .map((val) =>
                          moment(val).isValid() ? moment(val).format('DD-MM-YYYY') : 'Invalid Date'
                        )
                        .join(', ')
                    : 'N/A';
                } else {
                  return !formInputs?.value || formInputs?.value === ''
                    ? 'N/A'
                    : moment(formInputs?.value).isValid()
                    ? moment(formInputs?.value).format('DD-MM-YYYY')
                    : 'Invalid Date';
                }
              }

              if (
                formInputs.type === 'RadioButton' ||
                formInputs.type === 'Dropdown'
              ) {
                return !formInputs?.value || formInputs?.value === ''
                  ? 'N/A'
                  : formInputs?.value;
              }

              if (formInputs.type === 'Checkbox') {
                if (Array.isArray(formInputs?.value)) {
                  const filtered = formInputs.value.filter((item) => item?.value?.trim());
                  return filtered.length === 0
                    ? 'N/A'
                    : filtered.map((item, idx) => <div key={idx}>{item.value}</div>);
                } else {
                  return <div>{formInputs?.value?.trim() || 'N/A'}</div>;
                }
              }

              if (formInputs.type === 'MultiSelectDropdown') {
                return formInputs?.value &&
                  Array.isArray(formInputs.value) &&
                  formInputs.value.length > 0
                  ? formInputs.value.map((item, idx) => <div key={idx}>{item}</div>)
                  : 'N/A';
              }

              return 'N/A';
            };

            return (
              <TableRow key={rowId}>
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={isChecked(groupIndex, fieldIndex)}
                    onChange={() => handleCheckboxChange(groupIndex, fieldIndex, formInputs)}
                    style={{ pointerEvents: 'auto' }}
                  />
                </TableCell>
                <TableCell style={commonLabelStyle} className="tbCol">
                  {formInputs?.hideLabel ? '' : formInputs?.label}
                </TableCell>
                <TableCell style={commonValueStyle} className="tbCol">
                  {renderValue()}
                </TableCell>
              </TableRow>
            );
          })}
        </React.Fragment>
      ))}
    </Table>
  );
}

export default DynamicForm;
